export enum BOTTOM_STICKY_IDS {
    parcel = 'PARCEL',
    backToTop = 'BACK_TO_TOP',
    bottomMenu = 'BOTTOM_MENU',
    playBingoButton = 'PLAY_BINGO_BUTTON',
    bannerCta = 'BANNER_CTA',
    footer = 'FOOTER'
}
